import type { ButtonHTMLAttributes, FC } from "react";

import type { MultipleFlavorsSelectorItem } from "@ui/components/MultipleFlavorsSelector";
import { SelectionResultOverviewItem } from "@ui/components/MultipleFlavorsSelector/components/SelectionResultOverviewItem";
import classNames from "classnames";

import styles from "./MultibrandMultipleFlavorSelectorToggler.module.scss";

type MultibrandMultipleFlavorSelectorTogglerProps = {
  brandLabel: string;
  brandImgUrl?: string;
  isSelectorOpen: boolean;
  selectedBrandItems: (MultipleFlavorsSelectorItem & { count: number })[];
  hideOverview?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const MultibrandMultipleFlavorSelectorToggler: FC<MultibrandMultipleFlavorSelectorTogglerProps> = ({
  brandLabel,
  brandImgUrl,
  isSelectorOpen,
  selectedBrandItems,
  hideOverview,
  ...restProps
}) => {
  const selectedBrandItemsCount = selectedBrandItems.reduce((acc, i) => acc + i.count, 0);

  return (
    <button
      type="button"
      className={classNames(
        styles.container,
        isSelectorOpen && styles.active,
        selectedBrandItemsCount > 0 && styles.populated,
        hideOverview && styles.drawer
      )}
      data-testid="multibrand-multiple-flavor-selector-toggler"
      {...restProps}
    >
      <div className={styles.header}>
        {brandImgUrl && <img src={brandImgUrl} className={styles.brandIcon} alt="" />}
        <p className={styles.title}>{brandLabel}</p>
        {selectedBrandItemsCount > 0 && (
          <div className={styles.count}>
            <span>{selectedBrandItemsCount}</span>
          </div>
        )}
      </div>

      {!hideOverview && (
        <div className={classNames(styles.selection, isSelectorOpen && styles.active)} data->
          {selectedBrandItems.map((item) => (
            <SelectionResultOverviewItem
              key={item.id}
              label={item.name ?? null}
              description={item.description ?? undefined}
              imageUrl={item.image.url ?? undefined}
              quantity={item.count}
            />
          ))}
        </div>
      )}
    </button>
  );
};
